export const applyNoWrap = (inputString: string, words: Array<string>) => {
  let outputString = inputString;
  words.forEach(word => {
    const regex = new RegExp(`\\b${word}\\b`, 'g');
    outputString = outputString?.replace(regex, `<span style="white-space: nowrap;">${word}</span>`);
  });
  return outputString;
};
